import { CampaignStatus } from "~frontend/__generated__/graphql";

import { CampaignForView } from "../types";
import InitialSendReady from "./InitialSendReady";
import InitialSendRunning from "./InitialSendRunning";
import InitialSendScheduled from "./InitialSendScheduled";
import RoiTestAutosendPending from "./RoiTestAutosendPending";

const InitialSendComponents: {
  [K in CampaignStatus]: React.FC<{
    campaign: CampaignForView;
    hasActBlueIntegration: boolean;
    revealSendStatus: () => void;
  }> | null;
} = {
  [CampaignStatus.Draft]: null,
  [CampaignStatus.InitialSendReady]: InitialSendReady,
  [CampaignStatus.InitialSendCanceling]: null,
  [CampaignStatus.InitialSendScheduled]: InitialSendScheduled,
  [CampaignStatus.InitialSendRunning]: InitialSendRunning,
  [CampaignStatus.RoiTestAutosendPending]: RoiTestAutosendPending,
  [CampaignStatus.InitialSendComplete]: null,
  [CampaignStatus.Archived]: null,
};

export default InitialSendComponents;
